module.exports = __webpack_public_path__ + "img/noSearch.fa91042f.png";